import { JSConn } from "@/utilities/js-conn";
import { newSortOrderValue } from "@/utilities/sortOrder";

export default {
  name: "workOrderTasks",
  data() {
    return {
      task: {
        content: "",
        created_at: null,
        work_order_id: null,
      },
    };
  },
  computed: {
    workOrderTasks: function() {
      return this.$store.getters.workOrderTasks;
    },
    workOrder: function() {
      return this.$store.getters.workOrder;
    },
    isFieldWorker: function() {
      return this.$store.getters.isFieldWorker;
    },
  },
  methods: {
    taskClassObject(task) {
      let taskCompleted;
      if (task.status === "completed") {
        taskCompleted = true;
      } else {
        taskCompleted = false;
      }
      return {
        "completed-task": taskCompleted,
      };
    },
    copyTask(task) {
      const jsConn = new JSConn();
      jsConn.formParams = {
        work_order_task_id: task.id,
      };

      this.$store
        .dispatch("createWorkOrderTaskFromWorkOrderTask", jsConn)
        .then(() => {
          this.$emit("tasksChanged");
        });
    },
    deleteTask(task) {
      const jsConn = new JSConn();
      jsConn.formParams = task;
      this.$store.dispatch("deleteWorkOrderTask", jsConn).then(() => {
        this.$emit("tasksChanged");
      });
    },
    deleteLineItem(lineItem) {
      const jsConn = new JSConn();
      jsConn.formParams = lineItem;
      this.$store.dispatch("deleteWorkOrderTaskLineItem", jsConn).then(() => {
        this.$emit("tasksChanged");
      });
    },
    finishTask(task) {
      this.$router.push({
        name: "finishWorkOrderTaskForm",
        params: { workOrderTaskId: task.id },
      });
    },
    moveTaskUp(task) {
      const newSortOrder = newSortOrderValue(task, "up", this.workOrderTasks);
      if (newSortOrder.noChangeNeeded) {
        return;
      } else {
        const jsConn = new JSConn();
        jsConn.formParams = {
          id: task.id,
          sort_order: newSortOrder.newSortOrder,
        };

        this.$store.dispatch("updateWorkOrderTask", jsConn).then(() => {
          this.$emit("tasksChanged");
        });
      }
    },
    moveTaskDown(task) {
      const newSortOrder = newSortOrderValue(task, "down", this.workOrderTasks);
      if (newSortOrder.noChangeNeeded) {
        return;
      } else {
        const jsConn = new JSConn();
        jsConn.formParams = {
          id: task.id,
          sort_order: newSortOrder.newSortOrder,
        };

        this.$store.dispatch("updateWorkOrderTask", jsConn).then(() => {
          this.$emit("tasksChanged");
        });
      }
    },
  },
};
